module.exports = __webpack_public_path__ + "img/pay-value7.d0735585.png";